import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const BlogListing = () => {
  const [blogs, setBlogs] = useState([]);
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("All");

  const categories = ["All", "Business", "Consulting", "IT Services", "Logistics"];

  useEffect(() => {
    axios
      .get("http://localhost:5000/api/blogs")
      .then((res) => setBlogs(res.data))
      .catch((err) => console.error("Error fetching blogs:", err));
  }, []);

  const filteredBlogs = blogs.filter((blog) => {
    const matchesCategory = category === "All" || blog.category === category;
    const matchesSearch = blog.title.toLowerCase().includes(search.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <div className="max-w-6xl mx-auto px-4 py-8 font-epilogue">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold">Latest Blogs</h1>
        <input
          type="text"
          placeholder="Search keywords..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="border rounded-full px-4 py-2 w-64"
        />
      </div>

      {/* Category Tabs */}
      <div className="flex gap-6 border-b mb-6">
        {categories.map((cat) => (
          <button
            key={cat}
            onClick={() => setCategory(cat)}
            className={`pb-2 ${
              category === cat ? "border-b-2 border-green-600 text-green-600 font-semibold" : "text-gray-500"
            }`}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* Blogs Grid */}
      <div className="grid md:grid-cols-2 gap-6">
        {filteredBlogs.slice(0, 6).map((blog) => (
          <div key={blog.id} className="border rounded-lg overflow-hidden shadow hover:shadow-lg transition">
            <img src={blog.thumbnail} alt={blog.title} className="w-full h-56 object-cover" />
            <div className="p-4">
              <span className="inline-block bg-green-100 text-green-600 px-3 py-1 rounded-full text-sm mb-2">
                {blog.category}
              </span>
              <h2 className="text-xl font-bold mb-2">{blog.title}</h2>
              <p className="text-gray-600 text-sm mb-3">Posted on {new Date(blog.created_at).toDateString()}</p>
              <Link
                to={`/blog/${blog.id}`}
                className="text-green-600 hover:underline font-medium"
              >
                Read More →
              </Link>
            </div>
          </div>
        ))}
      </div>

      {/* View All Button */}
      {filteredBlogs.length > 6 && (
        <div className="flex justify-center mt-8">
          <button className="bg-green-600 text-white px-6 py-2 rounded-full hover:bg-green-700">
            View All Blogs
          </button>
        </div>
      )}
    </div>
  );
};

export default BlogListing;
